import { Injectable } from '@angular/core';
import { IPitch } from '../../../shared/model/pitch.interface';
import { IBooking } from '../../../shared/model/booking.interface';
import { ISlot } from './slot.component.interface';

@Injectable()
export class SlotService {
    getBookingFromSlot(slot: ISlot, pitch: any): IBooking {
        if (slot.relationships && slot.relationships.bookings && slot.relationships.bookings.data.length > 0 && pitch) {

            const bookingFound = slot.relationships.bookings.data.slice().reverse()
                .find(booking => pitch.id == booking.relationships.pitch.data.id);

            if (bookingFound && bookingFound.attributes.status === 'confirmed') {
                return bookingFound;
            }

            const cascadingBookingFound = slot.relationships.bookings.data.slice().reverse()
                .find(booking => pitch.id != booking.relationships.pitch.data.id);

            if (cascadingBookingFound && cascadingBookingFound.attributes.status === 'confirmed') {
                return cascadingBookingFound;
            }

            const cancelledBooking = slot.relationships.bookings.data.slice().reverse()
                .find(booking => booking.attributes.status === 'cancelled');

            if (cancelledBooking) {
                return cancelledBooking;
            }

            const pendingBooking = slot.relationships.bookings.data.slice().reverse()
                .find(booking => booking.attributes.status === 'pending');

            if (pendingBooking) {
                return pendingBooking;
            }

        }
    }

    getFirstBookingFromSlot(slot: ISlot): IBooking {
        if (slot.relationships && slot.relationships.bookings && slot.relationships.bookings.data.length > 0) {
            return slot.relationships.bookings.data[slot.relationships.bookings.data.length - 1];
        }
    }

    isBookingPresent(slots: Array<ISlot>, pitch: IPitch): boolean {
        let present = false;

        slots.forEach(slot => {
            if (this.isConfirmedBooking(slot, pitch)) {
                present = true;
            }
        });

        return present;
    }

    isBookingPresentInAnyPitch(slots: Array<ISlot>): boolean {
        let present = false;

        slots.forEach(slot => {
            if (this.isConfirmedBookingInAnyPitch(slot)) {
                present = true;
            }
        });

        return present;
    }

    isConfirmedBooking(slot: ISlot, pitch: IPitch): boolean {
        let found = false;
        const booking = this.getBookingFromSlot(slot, pitch);

        if (slot.attributes.availabilities === 0 && pitch && booking) {
            if (booking.attributes.status === 'confirmed' && booking.relationships.pitch.data.id === pitch.id) {
                found = true;
            }
        }

        return found;
    }

    isConfirmedBookingInAnyPitch(slot: ISlot): boolean {
        let found = false;
        const booking = this.getFirstBookingFromSlot(slot);

        if (slot.attributes.availabilities === 0 && booking && booking.attributes.status === 'confirmed') {
            found = true;
        }

        return found;
    }

    isCascadingBooking(slot: ISlot, pitch: IPitch): boolean {
        let found = false;
        const booking = this.getBookingFromSlot(slot, pitch);

        if (slot.attributes.availabilities === 0 && pitch && booking) {
            if (booking.attributes.status === 'confirmed' && booking.relationships.pitch.data.id !== pitch.id) {
                found = true;
            }
        }

        return found;
    }

    isCancelledBooking(slot: ISlot, pitch: IPitch): boolean {
        let found = false;
        const booking = this.getBookingFromSlot(slot, pitch);

        if (slot.attributes.availabilities === 0 && pitch && booking) {
            if (booking.attributes.status === 'cancelled') {
                found = true;
            }
        }

        return found;
    }

    isUnavailableSlot(slot: ISlot): boolean {
        let flag = false;

        // tslint:disable-next-line:max-line-length
        if (slot.attributes.availabilities === 0 && (slot.relationships && slot.relationships.bookings && slot.relationships.bookings.data.length === 0)) {
            flag = true;
        } else if (slot.attributes.availabilities === 0 && (!slot.relationships || (slot.relationships && !slot.relationships.bookings))) {
            flag = true;
        }

        return flag;
    }
}
